import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { Booking } from '../models/booking';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class BookingsResolverService implements Resolve<any> {
  constructor(private httpClient: HttpClient, private authService: AuthService) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> {
    return this.httpClient.get('/api/bookings', { headers: new HttpHeaders().append('Authorization','Bearer ' + this.authService.token)});
  }
}
